import script from "./ViewBankPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBankPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewBankPage.vue?vue&type=style&index=0&id=b138308c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b138308c"]])

export default __exports__